module.exports = __webpack_public_path__ + "static/media/stevie.607ff22d.jpg";